module.exports = __webpack_public_path__ + "assets/img/StructureBAIOS.ca4235fc.png";